import { SVGs } from "../../assets";
import { Flex } from "antd";
import Text from "../text";
import React from "react";

const Radio = ({
  children,
  className = "",
  checked,
  onChange = () => {},
  ...props
}) => {
  return (
    <Flex
      gap={"1rem"}
      align="center"
      onClick={() => onChange(checked)}
      className={"cursor-pointer " + className}
      {...props}
    >
      <img
        style={{ width: "2.2rem", height: "2.2rem" }}
        src={checked ? SVGs.radioActive : SVGs.checkboxInactive}
      />
      {children && <Text weight="600" color="secondary" children={children} />}
    </Flex>
  );
};

const Group = ({
  vertical = false,
  value = "",
  style,
  options = [],
  onChange = () => {},
  ...props
}) => {
  return (
    <Flex
      {...props}
      gap={"1rem"}
      vertical={vertical}
      children={React.Children.toArray(
        options.map((option) => {
          return (
            <Radio
              children={option.label}
              checked={value === option.value}
              onChange={() => onChange({ target: { value: option.value } })}
            />
          );
        })
      )}
    />
  );
};

Radio.Group = Group;
export default Radio;
